<template>
  <el-form
    ref="form"
    key="safetyCheckForm"
    class="safetyCheck-form"
    :model="form"
    :rules="formRules"
  >
    <el-form-item prop="email">
      <el-input v-model="form.email" placeholder="请输入公司邮箱账号" :disabled="type == 3">
        <img slot="prefix" class="icon-email" src="@/assets/images/icon-email.png">
      </el-input>
    </el-form-item>
    <el-form-item prop="code">
      <el-input v-model="form.code" class="code-input" placeholder="请输入验证码">
        <img slot="prefix" class="icon-lock" src="@/assets/images/icon-lock.png">
        <span slot="suffix" class="getCode-button" @click="getVerifyCode">{{ isGetting ? `${ currentSecond }s` : '获取验证码' }}</span>
      </el-input>
    </el-form-item>
    <el-form-item prop="desc">
      <el-button class="submit-button" type="primary" @click="submitSafetyCheck">下一步</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import { getEmailCode, verifyEmailCode } from '@/api'

import countDown from '@/mixins/countDown'

export default {
  mixins: [countDown],

  props: {
    // 默认邮箱
    value: {
      type: String,
      default: ''
    },

    // 1：注册，2：忘记密码，3：修改账号信息（发送邮箱验证码时会检验邮箱是否存在）
    type: {
      type: String,
      default: '1'
    }
  },

  data() {
    return {
      form: {
        email: '', // 公司邮箱
        code: '' // 验证码
      },
      formRules: {
        email: [
          {
            required: true,
            message: '请输入公司邮箱地址',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: '请输入正确的公司邮箱地址',
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: '请输入验证码',
            trigger: 'blur'
          }
        ]
      }
    }
  },

  watch: {
    value: {
      handler(newVal) {
        this.form.email = newVal
      },
      immediate: true
    }
  },

  methods: {
    /*
         * 获取验证码
        */
    getVerifyCode() {
      if (this.isGetting) return

      this.$refs.form.validateField('email', async errMsg => {
        if (!errMsg) {
          try {
            await getEmailCode({
              type: this.type,
              email: this.form.email
            })

            this.isGetting = true
            this.countDown()

            this.$message.success('发送成功！')
          } catch (error) {
            this.isGetting = false

            this.$message.error(error.message)
          }
        }
      })
    },

    /*
         * 提交安全校验
        */
    submitSafetyCheck() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await verifyEmailCode({
              email: this.form.email,
              code: this.form.code
            })
            this.$emit('success', this.form)
          } catch (error) {
            this.$emit('fail', this.form)

            this.$message.error(error.message)
          }
        } else {
          this.$emit('fail', this.form)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.safetyCheck-form {
    width: 519px;
    margin: 71px 0 0;
    /deep/ .el-input {
        font-size: 16px;
        > input {
            height: 56px;
            padding-left: 58px;
            border-radius: 6px;
        }
        .el-input__prefix {
            left: 29px;
            display: flex;
            align-items: center;
            transform: translateX(-50%);
        }
    }
    /deep/ .code-input {
        > input {
            padding-right: 121px;
        }
        .el-input__suffix {
            right: 24px;
            display: flex;
            align-items: center;
        }
        .getCode-button {
            font-size: 16px;
            color: #417EF7;
            cursor: pointer;
        }
    }
    .submit-button {
        width: 100%;
        height: 56px;
        font-size: 18px;
        border: 0;
        border-radius: 6px;
        margin: 20px 0 0;
    }
}
</style>
